import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ChatWidgetInputBase } from '../chat-widget-input-base';

@Component({
  selector: 'app-chat-date-of-birth-input',
  standalone: false,
  templateUrl: './chat-date-of-birth-input.component.html',
  styleUrls: ['./chat-date-of-birth-input.component.scss']
})
export class ChatDateOfBirthInputComponent extends ChatWidgetInputBase implements OnChanges {
  @Input() passengerName = '';
  @Input() savedValue: Record<string, unknown> | null = null;
  @Input() required?: boolean;
  @Output() answer = new EventEmitter<string>();
  @Output() skip = new EventEmitter<void>();

  dateOfBirth = '';
  chosenSummary: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.onlyLockedChanged(changes)) {
      return;
    }
    const saved = this.savedValue?.['dateOfBirth'];
    this.dateOfBirth = typeof saved === 'string' ? saved.slice(0, 10) : '';
    this.chosenSummary = null;
  }

  get isMandatory(): boolean {
    return this.required === true;
  }

  get isValid(): boolean {
    return !!this.dateOfBirth || !this.isMandatory;
  }

  onContinue(): void {
    if (this.locked || !this.isValid) {
      return;
    }
    if (!this.dateOfBirth) {
      this.chosenSummary = 'Skipped';
      this.skip.emit();
      return;
    }
    this.chosenSummary = this.dateOfBirth;
    this.answer.emit(this.dateOfBirth);
  }

  onSkip(): void {
    if (this.locked) {
      return;
    }
    this.chosenSummary = 'Skipped';
    this.skip.emit();
  }
}
